import { StudyMemberDto } from '@interfaces-clean/study-member.interface';
import { SubjectObservationGridRow } from '@interfaces-clean/subject-monitoring/subject-observations';
import { SubjectReviewNoteDto } from '@interfaces-clean/subject-monitoring.interface';

export const sortStudyMemberData = (smStudyMembersData?: StudyMemberDto[]) => {
    const sortedOwners = (smStudyMembersData ?? [])
        // Remove bad data (since everything is nullable...)
        .filter((x) => typeof x.ref === 'string' && typeof x.name === 'string' && typeof x.acitve === 'boolean')
        .map((x) => ({
            id: x.ref!,
            value: x.name!,
            active: x.acitve!,
            groupedBy: x.acitve ? 'Active' : 'Inactive',
            disabled: !x.acitve,
        }))
        .sort((a, b) => {
            const aActive = a.groupedBy === 'Active' ? 1 : 0;
            const bActive = b.groupedBy === 'Active' ? 1 : 0;

            // Primary sort: Active descending (true first)
            if (bActive !== aActive) {
                return bActive - aActive;
            }

            // Normalize nullable strings
            const aTitle = a.value ?? '';
            const bTitle = b.value ?? '';

            // Secondary sort: alphabetical ascending
            return aTitle.localeCompare(bTitle);
        });
    return sortedOwners;
};

/**
 * Builds an observation grid row from a subject note so the existing Edit Observation
 * dialog can be reused when converting a note. A note has no reviews, actions, owner,
 * root cause, or comments, so those fields are defaulted to empty.
 */
export const mapNoteToObservationGridRow = (note: SubjectReviewNoteDto): SubjectObservationGridRow => ({
    type: 'Note',
    review_title: note.reviewTitle ?? null,
    status: 'Open',
    subject: note.subjectNumber ?? '',
    obs_status_val: '',
    review_log_created_for_latest_dataset: null,
    association: note.association ?? '',
    data_listing: note.dataListing ?? null,
    data_listing_active: null,
    panel: null,
    panel_id: null,
    panel_active: null,
    panel_ref: null,
    observation_date: note.observationDate ?? '',
    observation: note.noteText ?? '',
    owner_ref: null,
    owner_id: null,
    owner_name: null,
    owner_name_active: null,
    decision: null,
    review_log_id: null,
    decision_active: null,
    // The note carries the dataset date as a 'DD-MMM-YYYY' display string; the dialog expects a UTC date.
    dataset_opened_on: note.datasetOpenedOn!,
    dataset_id: '',
    reviews: '0',
    open_actions: '0',
    total_actions: '0',
    recent_action: null,
    root_cause: null,
    comments: null,
    updated_date: note.updatedDate ?? '',
    closed_date: null,
    closed_date_populated_on: null,
    updated_by: note.updatedByName ?? '',
    created_date: note.created ?? '',
    created_by: note.createdByName ?? '',
    record_id: note.id ?? '',
    is_deleted: 'false',
    is_latest: 'true',
    id: note.observationId != null ? String(note.observationId) : '',
    subject_review_log_created_for_latest_dataset: null,
    selected: false,
});
